export enum EProfileElementStatus {
  Disabled = 'Disabled',
  Optional = 'Optional',
  Mandatory = 'Mandatory',
  Readonly = 'Readonly',
  AddOnly = 'AddOnly',
}
